<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="accountsData"
      style="width: 100.1%;"
    >
      <!-- 删除 -->
      <template slot-scope="{ row, index }" slot="delete">
        <Button
          type="success"
          size="small"
          v-hasPermission="['permissionsConfigurationManagement:accounts:log']"
          @click="rowClick(row)"
          >{{
            $t("permission_configuration_management.account.operationLog")
          }}</Button
        >
        <span @click="doDelete(index)">
          <Button
            type="error"
            size="small"
            @click="accountsDelmodal = true"
            v-hasPermission="[
              'permissionsConfigurationManagement:accounts:delete_account'
            ]"
            >{{
              $t("permission_configuration_management.account.delete")
            }}</Button
          >
        </span>
      </template>
    </Table>
    <!-- 操作日志详情 -->
    <configuration-management-operation-log
      v-if="isShowOperationLog"
      ref="configurationManagementOperationLog"
    ></configuration-management-operation-log>
    <!-- 删除账户模式框 -->
    <Modal v-model="accountsDelmodal" width="360" :mask-closable="false">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align:center">
        <p>
          {{ $t("alarms.common.sureDelete") }}
          {{ accountsName }} 下关联的所有数据吗?
        </p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          :loading="modal_loading"
          @click="removeAccount()"
          :disabled="isDisable"
          >删除</Button
        >
      </div>
    </Modal>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
    <!-- 弹窗，新增/编辑 -->
    <add-or-update-accounts
      v-if="addOrUpdateVisible"
      ref="addOrUpdate"
    ></add-or-update-accounts>
  </div>
</template>
<script>
import ConfigurationManagementOperationLog from "../../common/ConfigurationManagementOperationLog.vue";
import { setCookie, getCookie } from "../../../../utils/cookieUtil.js";
let self = {}
export default {
  name: "TableAccounts",
  components: {
    AddOrUpdateAccounts: () => import("./AddOrUpdateAccounts"),
    ConfigurationManagementOperationLog
  },
  data() {
    return {
      authenticationType: [
        "IAM AK/SK",
        "Account Service",
        "Assume Role",
        "IAM User",
        "Service Account"
      ],
      isShowOperationLog: false,
      addOrUpdateVisible: false,
      val: "",
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      accountsDelmodal: false,
      accountsName: "",
      modal_loading: false,
      isDisable: false,
      columns: [
        {
          title: this.$t(
            "permission_configuration_management.account.accountName"
          ),
          key: "name",
          render: (h, params) => {
            return h(
              "a",
              {
                style: {
                  textDecoration: "underline"
                },
                on: {
                  click: () => {
                    this.addOrUpdateHandle(params.row.id, params.row);
                  }
                }
              },
              params.row.name
            );
          }
        },
        {
          title: this.$t(
            "permission_configuration_management.account.accountType"
          ),
          key: "accountTypeName"
        },
        {
          title: this.$t(
            "permission_configuration_management.account.accountId"
          ),
          key: "accountId"
        },
        {
          title: this.$t("permission_configuration_management.account.region"),
          key: "areaType",
          render: (h, params) => {
            let areaType = params.row.areaType; // 1:中国 2:海外
            if (areaType === 1) {
              return h(
                "div",
                this.$t("permission_configuration_management.account.china")
              );
            }
            if (areaType === 2) {
              return h(
                "div",
                this.$t("permission_configuration_management.account.overseas")
              );
            }
          }
        },
        {
          title: this.$t(
            "permission_configuration_management.account.authType"
          ),
          key: "authenticationType"
        },
        {
          title: "Project ID",
          key: "projectId"
        },
        // {
        //   title: this.$t(
        //     "permission_configuration_management.account.dataSource"
        //   ),
        //   key: "sourceData",
        //   render: (h, params) => {
        //     let sourceData = params.row.sourceData; // 0:原生 1:ELK
        //     if (sourceData === 0) {
        //       return h(
        //         "div",
        //         this.$t(
        //           "permission_configuration_management.account.protogenesis"
        //         )
        //       );
        //     }
        //     if (sourceData === 1) {
        //       return h(
        //         "div",
        //         this.$t("permission_configuration_management.account.elk")
        //       );
        //     }
        //   }
        // },
        {
          title: this.$t("common.operation"),
          slot: "delete"
        }
      ],
      accountsData: []
    };
  },
  mounted() {
    this.getData();
    self = this;
  },
  methods: {
    showAll() {
      self.getData();
    },
    doDelete(index) {
      this.lineIndex = index;
      this.accountsName = this.accountsData[index].name;
    },
    // 分页显示数据
    getData() {
      // 获取AccountSearch里面的搜索内容
      eventBus.$on("accountSearchName", (val) => {
        this.accountName = val;
      });
      eventBus.$on("companyId", (val) => {
        this.companyId = val;
      });
      //账户列表分页
      this.$api.account
        .pageAccount({
          accountName: this.accountName,
          companyId: this.companyId,
          pageNum: this.current,
          pageSize: this.pageSize
        })
        .then(res => {
          this.accountsData = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
          // 认证方式
          for (let i = 0; i < this.accountsData.length; i++) {
            this.accountsData[i].authenticationType = this.authenticationType[
              this.accountsData[i].authenticationType
            ];
          }
        });
    },
    changePage(current) {
      this.current = current;
      this.getData();
    },
    changeSize(pageSize) {
      this.pageSize = pageSize;
      this.getData();
    },
    // 删除
    removeAccount() {
      this.isDisable = true; //开始可以点击
      this.modal_loading = true;
      let lineIndex = this.lineIndex;
      //账户删除
      this.$api.account
        .deleteAccount("id", this.accountsData[lineIndex].id)
        .then(res => {
          if (
            lineIndex == 0 &&
            (this.current - 1) * this.pageSize + 1 == this.dataTotal
          ) {
            this.current = this.current - 1;
          }
          this.dataTotal = this.dataTotal - 1;
          this.getData();
          this.accountsDelmodal = false;
          this.$Message.success("删除成功");
        }).finally(() => {
          this.isDisable = false;
          this.modal_loading = false;
        });
    },
    // 销毁
    beforeDestroy() {
      eventBus.$off("accountSearchName");
      eventBus.$off("companyId");
    },
    // 编辑
    /*************************************************************************/
    addOrUpdateHandle(id, row) {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs.addOrUpdate.init(id, row);
        });
      });
    },
    // 操作日志
    /****************************************************/
    rowClick(row) {
      this.isShowOperationLog = true;
      this.$nextTick(function() {
        this.$refs.configurationManagementOperationLog.getConfigurationManagementOperationLogList(
          row.id,
          6
        );
      });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
.addPolicies-main {
  width: 96%;
  min-height: 100px;
  border: 1px solid #dcdee2;
  border-radius: 4px;
  padding: 0 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/account/TableAccounts.vue